
import React from 'react';
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from '@/components/ui/context-menu';
import { Trash2, RotateCcw } from 'lucide-react';

interface ChatItemContextMenuProps {
  children: React.ReactNode;
  onDelete?: () => void;
  onRestore?: () => void;
  disabled?: boolean;
  isDeleted?: boolean;
  canRestore?: boolean;
}

export const ChatItemContextMenu: React.FC<ChatItemContextMenuProps> = ({
  children,
  onDelete,
  onRestore,
  disabled = false,
  isDeleted = false,
  canRestore = false
}) => {
  const handleDelete = (e: Event) => {
    e.preventDefault();
    if (!disabled && onDelete) {
      onDelete();
    }
  };

  const handleRestore = (e: Event) => {
    e.preventDefault();
    if (!disabled && onRestore) {
      onRestore();
    }
  };

  // Se a conversa está deletada mas o usuário não pode restaurar, não mostrar menu
  if (isDeleted && !canRestore) {
    return <>{children}</>;
  }

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        {children}
      </ContextMenuTrigger>
      
      <ContextMenuContent className="w-48 bg-black/90 border border-luxury-gold/20 backdrop-blur-sm">
        {isDeleted && canRestore ? (
          <ContextMenuItem
            className="flex items-center gap-2 text-green-400 hover:bg-green-500/20 hover:text-green-300 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            onSelect={handleRestore}
            disabled={disabled}
          >
            <RotateCcw className="h-4 w-4" />
            Restaurar conversa
          </ContextMenuItem>
        ) : (
          <ContextMenuItem
            className="flex items-center gap-2 text-red-400 hover:bg-red-500/20 hover:text-red-300 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            onSelect={handleDelete}
            disabled={disabled}
          >
            <Trash2 className="h-4 w-4" />
            Apagar conversa
          </ContextMenuItem>
        )}
      </ContextMenuContent>
    </ContextMenu>
  );
};
